import { StepPageWrapper } from '@Layout/StepPageWrapper';
import { useTranslation } from 'react-i18next';
import { useSetPasswordLogic } from './hooks/useSetPasswordLogic';
import { PasswordInput } from '@Components/inputs/PasswordInput';
import { FormProvider } from 'react-hook-form';
import { useBlocker } from '@tanstack/react-router';
import { routesModel } from '@Router/router.consts';
import { RoutesMap } from '@Router/router.types';

export const SetPassword = () => {
  const { t } = useTranslation('inviteTeamMember');
  const { formMethods, handleSubmit, isSettingPassword, isCompletingOnboarding, isSendingConsent } =
    useSetPasswordLogic();

  useBlocker({
    shouldBlockFn: ({ next }) => {
      if (next.routeId === routesModel[RoutesMap.INVITE_TEAM_MEMBER_FINISHED].path) {
        return false;
      }
      return true;
    },
  });

  return (
    <FormProvider {...formMethods}>
      <StepPageWrapper
        heading={t('setPassword.title')}
        formMethods={formMethods}
        handleSubmit={() => handleSubmit(formMethods.getValues())}
        isLoading={isSettingPassword || isCompletingOnboarding || isSendingConsent}
        footerInputSlot={<></>}
        customSubmitTitle={t('setPassword.submit')}
        shouldStrechCta>
        <div className='mt-[24px]'>
          <PasswordInput />
        </div>
      </StepPageWrapper>
    </FormProvider>
  );
};
